import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

/**
 * Abstraction du Firebase Remote Config.
 * Retourne la valeur par défaut (true) jusqu'à ce que Firebase soit branché.
 *
 * Pour brancher Firebase Remote Config :
 *   1. npm install firebase @angular/fire
 *   2. Initialiser l'app Firebase dans app.module.ts
 *   3. Remplacer getBoolean() par :
 *        import { getRemoteConfig, fetchAndActivate, getBoolean } from 'firebase/remote-config';
 *        const rc = getRemoteConfig(app);
 *        rc.defaultConfig = { ft_externe_login_playlist_active: true };
 *        rc.settings.minimumFetchIntervalMillis = 5 * 60 * 1000;
 *        await fetchAndActivate(rc);
 *        return getBoolean(rc, key);
 */
@Injectable({ providedIn: 'root' })
export class RemoteConfigService {
  getBoolean(key: 'ft_externe_login_playlist_active'): Observable<boolean> {
    // Valeur par défaut : true (spec)
    return of(true);
  }
}
